module.exports = __webpack_public_path__ + "img/view_btn.05251616.png";